export const screenSizes = {
  mobileOrTablet: '820px',
};